/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoSalesforceProdIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-prod" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceProdIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/icon' },
);

const LazyForgeUnitoSalesforceProdSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-salesforce-prod-search-result" */ './utils').then(
			(m) => m.ForgeUnitoSalesforceProdSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-salesforce-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoSalesforceProdIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoSalesforceProdIconComponent />
	</Suspense>
);

export const ForgeUnitoSalesforceProdSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoSalesforceProdSearchResultIconComponent />
	</Suspense>
);
